export default {
    '申请人':  "Applicant Name",
    "邮箱": "Email Address",
    "其他联系方式": "Mobile Phone Number(Optional)",
    "profile_long": "Decathlon Profile(like: EXU22)",
    "用途": "Remark",
    "账号": "Account",
    "工厂": "Factory",
    "迪卡侬用户": "Decathlon Users",
    "外部用户": "External users",
    "取消": "Cancel",
    "发送": "Send",
    "公司名称": "Company Name",
    "外部用户": "External Users",
    "外部用户登录": "External Users Login",
    "忘记密码": "Forget Password",
    "没有账号": "No Account",
    "提醒": "Remind",
    "此密码已使用超过三个月，请前去修改密码方可使用": "Your Password Has Been Used For More Than Three Months, Please Change It",
    "修改密码": "Chane Password",
    "修改成功": "Change Successfully",
    "你已成功修改密码，请重新登录": "You Have Successfully Changed Your Password, Please Login Again",
    "关闭": "Close",
    "你的账号没有维护邮箱，为保证账号安全，请去维护": "You Account Dont Have Email,Please Add Email In Order To Ensure The Security",
    "维护邮箱": "Add Email",
    "邮箱": "Email",
    "获取验证码": "Get Verification Code",
    "验证码": "Verification Code",
    "输入新密码": "Enter New Password",
    "重新输入新密码": "Re-enter the new password",
    "我的组织": "My Organization",
    "数据权限": "Data Permission",
    "自己组织": "My Organization",
    "指定组织": "Choose Organization",
    "全部组织": "All Organization",
    "个人信息": "Personal Information",
    "我的密码": "My PassWord",
    "组织与权限": "Organization And Permission",
    "退出登录": "log out",
    "我的数据组": "My data set",
    "我的权限": "My permission",
    "新增": "New",
    "新增token": "",
    "Token名称": "",
    "密码规则": "Password rules",
    "密码长度8-16位": "Password length is 8-16 bits",
    "须同时包含数字，字母，特殊字符中的任意两种": "Must contain any two of the digits, letters, or special characters",
    "保存": "save",
    "旧密码": "The old password",
    "新密码": "New Password",
    "我的邮箱": "My Email",
    "邮箱地址": "Email Address",
    "操作": "Operation",
    "请立即维护您的邮箱": "Please Add Email",
    "更换邮箱": "Change Email",
    "绑定邮箱": "Bind Email",
    "我的微信": "My Wechat",
    "微信昵称": "Wechat Name",
    "请绑定微信": "Please Bind Wechat",
    "解除绑定微信": "Unbind Wechat",
    "绑定微信": "Bind Wechat",
    "更换邮箱验证": "Change Email Validate",
    "是否解除绑定微信": "Are You Sure Unbind WeChat",
    "确认解绑": "Confirm The Unbundling",
    "确定": "Sure",
    "去申请": "Register here.",
    "登录": "Login",
    "用户名": "UserName",
    "密码": "Password",
    "用户名不能为空": "The Username Cannot Be Empty",
    "密码不能为空": "The Password Cannot Be Empty",
    "账号不能为空": "The Account Cannot Be Empty",
    "验证码不能为空": "The Validate Code Cannot Be Empty",
    "邮箱不能为空": "The Email Cannot Be Empty",
    "邮箱格式不正确": "Incorrect Mailbox Format",
    "两次密码不一致": "The Passwords Do Not Match",
    "重新获取(": "Reacquire (",
    "密码长度不能小于8位": "Password Length Must Not Be Less Than 8 Bits",
    "密码长度不能大于16位": "Password Length Must Not Be Greater Than 16 Digits",
    "申请人不能为空": "The Applicant Cannot Be Empty", 
    "用途不能为空": "The Remark Cannot Be Empty",
    "公司名称不能为空": "The Company Cannot Be Empty",
    "请按规则填写": "Please fill in according to the rules",
    "修改成功": "Modify the success",
    "修改失败": "Modify the falied",
    "请填写旧密码": "Please fill in the old password",
    "微信绑定成功": "WeChat binding was successful",
    "解除绑定成功": "Successful unbinding",
    "保存成功": "Save Successfully",
    "邮箱和账号不能为空": "Email And Account Cannot Be Empty",
    "成衣厂": "FG Supplier",
    "面料厂": "CPT Supplier",
    "国家": "Country",
    "DPP": "DPP",
    "角色": "Role",
    "国家不能为空": "The Country Cannot Be Empty",
    "DPP不能为空": "The DPP Cannot Be Empty",
    "角色不能为空": "The Role Cannot Be Empty",
    "请选择国家": "Please Select Country",
    "请选择DPP": "Please Select DPP",
    "请选择角色": "Please Select Role",
    "我们应该怎么称呼您": "What shall we call you",
    "邮件地址": "email address",
    "手机号（选填）": "Mobile Phone number (optional)",
    "请输入账号": "Please enter account number",
    "请描述": "Please describe",
    "请输入工厂名称": "Please enter the factory name",
    "登录失败": "Logon failed",
    "该用户没有获得审批,请申请账号": "The user has not been approved. Please apply for an account",
    "查询用户信息失败": "Description Failed to query user information",
    "用户被禁止访问": "The user is denied access",
    "秒后跳转到登录页面,如未自动跳转请点击": "seconds later, the login page is displayed. If the login page is not automatically displayed, click"
    // "": "",
    // "": "",
    // "": "",
    // "": "",
    // "": "",
    // "": "",
    // "": "",
    // "": "",
    // "": "",
    // "": "",


};



// WEBPACK FOOTER //
// ./src/language/en-US.js